import SearchPage from "pages/searchPage/SearchPage";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  Outlet,
} from "react-router-dom";
import ProtectedRoute from "routes/ProtectedRoute";
import LoginPage from "components/LoginPage";
import AuthContextProvider from "database/useAuth";
import DatabaseReaderContextProvider from "database/useDatabaseReader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LandingPage from "pages/landingPage/LandingPage";
import { ProjectsMainPage } from "pages/projectsMainPage/ProjectsMainPage";
import { ProjectBuilderPage } from "pages/projectBuilderPage/ProjectBuilderPage";
import { ProjectViewerPage } from "pages/projectViewerPage/ProjectViewerPage";
import AdminPage from "pages/adminPage/AdminPage";
import StockIssuesPage from "pages/stockIssuesPage/StockIssuesPage";
import StockIssuesRouteGuard from "pages/stockIssuesPage/StockIssuesRouteGuard";
import ProjectSearchContextProvider from "database/useProjectSearch";
import { NotFound } from "pages/notFound/NotFound";

const App = () => {
  return (
    <BrowserRouter
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <AuthContextProvider>
        <DatabaseReaderContextProvider>
          <Routes>
            <Route index element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/private" element={<ProtectedRoute />}>
              <Route path="search" element={<SearchPage />} />
              <Route path="admin" element={<AdminPage />} />
              <Route element={<ProjectSearchContextProvider />}>
                <Route path="projects" element={<ProjectsMainPage />} />
                <Route
                  path="stock-issues"
                  element={
                    <StockIssuesRouteGuard>
                      <StockIssuesPage />
                    </StockIssuesRouteGuard>
                  }
                />
              </Route>
              <Route
                path="projects/builder/:projID/"
                element={<ProjectBuilderPage />}
              />
            </Route>
            <Route path="/public/sharing/:projID" element={<ProjectViewerPage />} />
            <Route path="/not_found" element={<NotFound />} />
            <Route path="/public/*" element={<Navigate to="/not_found" />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </DatabaseReaderContextProvider>
      </AuthContextProvider>

      <ToastContainer
        position="top-right"
        theme="light"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        // draggable
        pauseOnHover
      />
      {/* </DatabaseReaderContextProvider> */}
      {/* </AuthContextProvider> */}
    </BrowserRouter>
  );
};

export default App;
